import { IconProps, iconA11yProps } from '../types';

export const AccessDenied = ({ classNames, label }: IconProps) => (
    <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88" {...iconA11yProps(label)}>
        <circle cx="44" cy="44" r="41.5" fill="none" strokeMiterlimit="10" strokeWidth="5" />
        <line x1="14.66" y1="14.66" x2="73.34" y2="73.34" fill="none" strokeMiterlimit="10" strokeWidth="5" />
    </svg>
);
